export var prefixAppBrandHexColor = function (color) {
    return "#".concat(color);
};
//# sourceMappingURL=prefixAppBrandHexColor.js.map